import { messaging } from '../lib/messaging';
function setFlag(flag, value) {
    messaging.sendMessage('FLAG/SET', { [flag]: value });
}
function removeFlag(flag) {
    messaging.sendMessage('FLAG/REMOVE', flag);
}
function getFlags() {
    messaging.sendMessage('FLAG/GET');
}
export default {
    setFlag,
    getFlags,
    removeFlag,
};
